import angular from 'angular';
import uiRouter from 'angular-ui-router';
import DashboardService from 'dashboard.service';
import MessagesService from 'messages.service';
import circleChartComponent from 'circle-chart';
import horizontalBarchartComponent from 'horizontal-barchart';
import messageFormComponent from 'message-form';
import notificationCardComponent from 'notification-card';
import dashboardComponent from './dashboard.component';

let dashboardModule = angular.module('dashboard', [uiRouter])
  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
      .state('engineer.dashboard', {
        url: '/dashboard',
        template: '<dashboard class="dashboard"></dashboard>'
      });
  })
  .service('Dashboard', DashboardService)
  .service('Messages', MessagesService)
  .component('circleChart', circleChartComponent)
  .component('horizontalBarchart', horizontalBarchartComponent)
  .component('messageForm', messageFormComponent)
  .component('notificationCard', notificationCardComponent)
  .component('dashboard', dashboardComponent);

export default dashboardModule;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/dashboard/index.js